import { useEffect, useRef } from "react";
import { loadGoogleMaps } from "@/lib/google-maps-loader";

interface Props {
  lat: number;
  lng: number;
  zoom?: number;
}

export const LocationMap = ({ lat, lng, zoom = 17 }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef<any>(null);
  const markerRef = useRef<any>(null);

  useEffect(() => {
    let cancelled = false;
    loadGoogleMaps().then((g) => {
      if (cancelled || !containerRef.current) return;
      if (!mapRef.current) {
        mapRef.current = new g.maps.Map(containerRef.current, {
          center: { lat, lng },
          zoom,
          disableDefaultUI: true,
          zoomControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          clickableIcons: false,
          gestureHandling: "cooperative",
        });
        markerRef.current = new g.maps.Marker({
          map: mapRef.current,
          position: { lat, lng },
        });
      } else {
        mapRef.current.setCenter({ lat, lng });
        mapRef.current.setZoom(zoom);
        markerRef.current?.setPosition({ lat, lng });
      }
    });
    return () => {
      cancelled = true;
    };
  }, [lat, lng, zoom]);

  return (
    <div
      ref={containerRef}
      className="w-full h-64 sm:h-72 rounded-lg overflow-hidden border border-border bg-muted"
      aria-label="Mapa de la dirección seleccionada"
    />
  );
};
